import NotificationType from '../NotificationType';

export default class EventFormApproved extends NotificationType {
  get icon() {
    return 'fa-solid fa-calendar-check';
  }

  resolveRoute(notification) {
    const eventFormId = notification.params?.event_form_id;
    const clubId = notification.params?.club_id;
    if (!eventFormId || !clubId) return null;

    return { name: 'club-event-show', params: { id: clubId, eventFormId } };
  }
}
